import React, { FC } from "react";
import { Paper as MuiPaper, PaperProps } from "@mui/material";

const Paper: FC<PaperProps> = (props) => <MuiPaper {...props} />;

export default Paper;
